import Collapse from './Collapse.vue'
import CollapseItem from './CollapseItem.vue'

export { Collapse, CollapseItem }
